<h2 i18n="@@DialogIncorrectCaptchaCaption">
  <mat-icon style="vertical-align: middle">error</mat-icon>&nbsp;Errore captcha</h2>
<p i18n="@@DialogIncorrectCaptchaText">Il captcha inserito non è corretto</p>

<div style="margin-top: 10px; text-align: right">
  <button mat-raised-button (click)="closeDialog()" i18n="@@DialogClose">Chiudi</button>
</div>



// WEBPACK FOOTER //
// ./src/app/dialogs/incorrect-captcha-dialog/incorrect-captcha-dialog.html